<template>
<div id="loading-wrapper">
    <div id="loading-text">LOADING</div>
  <div id="loading-content"></div>
</div>
</template>

<script>
    import axios from 'axios'
export default {
    data() {
        return {

        }
    },
    methods: {
        async onSubmitLogin() {
            const headers = {
  'Content-Type': 'application/json',
  'Authorization': 'Bearer '+this.$route.params.token
//   https://api.job4u.pk
}
            axios.get('get-token-user',{
    headers: headers
  }).then((response) => {
    
            if(response.data.status == true){ 
                var fuser = response.data.user;
                var user = response.data.user.user;
            var email = user.email;
                    this.$store.dispatch('logout');

                    // dummy delay
                    setTimeout(() => {
                        // send login request
                        this.$store
                            .dispatch('socialLogin',user)
                            // go to which page after successfully login

                            .then((res) => {
                                localStorage.setItem("user", JSON.stringify(fuser.user));
                                localStorage.setItem("token", fuser.user.token);
                                /////////////////////////////////////////////////////////
                                if (fuser.user.role == "Direct Employer") {
                                    localStorage.setItem(
                                        "pic",
                                        JSON.stringify(fuser.profile.profile_pic)
                                    );
                                    localStorage.setItem("profile", JSON.stringify(fuser.profile));
                                } else {
                                    localStorage.setItem(
                                        "pic",
                                        JSON.stringify(fuser.profile.profile_pic)
                                    );
                                    localStorage.setItem("profile", JSON.stringify(fuser.profile));
                                }
                                /////////////////////////////////////////////////////////
                                var jobSesstion = JSON.parse(
                                    sessionStorage.getItem("jobSesstion")
                                );
                                if (jobSesstion) {
                                    window.location.href =
                                        "/jobs-careers/pakistan/" +
                                        jobSesstion.city +
                                        "/" +
                                        jobSesstion.title +
                                        "/" +
                                        jobSesstion.id;
                                } else {
                                    window.location.href = "/dashboard";
                                }
                            });
                        
                    }, 1000);
                }
                else{
                    this.$router.push('/login')
                }
            });
        },
    },
    created() {
        this.onSubmitLogin()
    }
}
</script>

<style lang="scss" scoped>
  #loading-wrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  #loading-text {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    color: rgb(20, 121, 60);
    width: 100px;
    height: 30px;
    margin: -7px 0 0 -45px;
    text-align: center;
    font-family: 'PT Sans Narrow', sans-serif;
    font-size: 20px;
  }

  #loading-content {
    display: block;
    position: relative;
    left: 50%;
    top: 50%;
    width: 170px;
    height: 170px;
    margin: -85px 0 0 -85px;
    border: 3px solid #F00;
  }

  #loading-content {
    border: 3px solid transparent;
    border-top-color: rgb(121, 61, 185);
    border-bottom-color: rgb(121, 61, 185);
    border-radius: 50%;
    -webkit-animation: loader 2s linear infinite;
    -moz-animation: loader 2s linear infinite;
    -o-animation: loader 2s linear infinite;
    animation: loader 2s linear infinite;
  }

  @keyframes loader {
    0% {
      -webkit-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>
